export default (state = {}, action = {}) => {
	if (action.type === 'PRODUCT_CACHE') {
		const { products, filterArrays, filterDescriptions, localized, searchTerms } = action.productCache;

		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					products,
					filterArrays,
					filterDescriptions,
					localized,
					searchTerms,
				},
			},
		};
	}

	return state;
};
